// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WrMn","error":"styles_error__2URhB","success":"styles_success__LYmER"};